export const staticImages = {
    sampleVendor: require('./sample_vendor.png'),
    sampleCar: require('./default_car_image.png'),
    sampleWorld: require('./sample_world.png'),
    sampleUser: require('./sample_user.png'),
    appLogo: require('./appLogo.png'),
    sampleProduct: require('./sample-product.png'),
    clientCarLightsOnDark: require('./client/car-lights-on-dark.png'),
    clientCarLightsOnLight: require('./client/car-lights-on-light.png'),
    clientCarLightsOnDarkAlone: require('./client/car-lights-on-dark-alone.png'),
    clientCarLightsOnLightAlone: require('./client/car-lights-on-light-alone.png'),
    clientCarNoLights: require('./client/car-no-lights.png'),
    clientCarParked: require('./client/car-parked.png'),
    clientCarParkedLightGif: require('./client/car-parked-light.gif'),
    clientCarParkedDarkGif: require('./client/car-parked-dark.gif'),
    clientLogoLineDark: require('./client/logo-line-dark.png'),
    clientLogoLineLight: require('./client/logo-line-light.png'),
    clientCarBookedLightGif: require('./client/car-booked-light.gif'),
    clientCarBookedDarkGif: require('./client/car-booked-dark.gif'),
}